<template>
  <v-container>
    <v-form ref="form" @submit.prevent="logIt" method="POST" v-model="valid" lazy-validation>
      <v-card class="elevation-0" :color="color || `transparent`">
        <v-card-text class="pa-0">
          <v-textarea
            id="note"
            name="note"
            v-model="note"
            label="Message"
            :color="color ?  `secondary` : 'primary'"
            placeholder="Post message to thread"
            :rules="[v => !!v || 'A note is required to post to this thread']"
            hide-details
            required
            class="mt-0"
            box
            :light="!!!color"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="color ?  `secondary` : 'primary'" type="submit" flat round>Post Message</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-card v-if="events.length > 0" flat :color="color || `transparent`">
      <v-toolbar flat :color="color || `transparent`" :light="!!!color">
        <v-toolbar-title>
          <h4 class="text-xs-center">{{ total }} Message/Event(s)</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-timeline
          :dense="$vuetify.breakpoint.xsOnly"
          :class="`py-0 ${!color ? 'primary--text' : ''}`"
        >
          <v-timeline-item v-for="(event, index) in events" :key="index">
            <template v-slot:icon>
              <v-icon
                :color="
                  `${event.event === 'pin_drop' ? 'success' : 'grey lighten-3'}`
                "
              >{{ event.event }}</v-icon>
            </template>
            <template v-slot:opposite>
              <h4>{{ event.createdBy || "System Event" }}</h4>
              <h5>{{ localizeDate(event.createdOn, true) }}</h5>
            </template>
            <v-card
              :color="
                `${
                  event.event === 'pin_drop'
                    ? 'success'
                    : 'grey lighten-3 primary--text'
                }`
              "
              class="elevation-4"
            >
              <v-card-title v-if="$vuetify.breakpoint.xsOnly" class="headline pb-0">
                <h4>{{ event.createdBy || "System Event" }}</h4>
              </v-card-title>

              <v-card-text style="pa-2">
                <h4 v-if="$vuetify.breakpoint.xsOnly">{{ localizeDate(event.createdOn, true) }}</h4>
                <v-sheet style="background-color:inherit;color:inherit;" v-html="event.note"></v-sheet>
                <div v-if="event.attachment && event.note.includes('usps')">
                  <a
                    :href="`data:image/jpg;base64, ${event.attachment}`"
                    :download="`shippingLabel.png`"
                    style="color: white;"
                  >Click to Download</a>
                  <v-img
                    :src="`data:image/jpg;base64, ${event.attachment}`"
                    style="width:100%;"
                  ></v-img>
                </div>
                <div v-else-if="event.attachment">
                  <a
                 
                  :href="`data:${getMimeType(event.attachment)};base64, ${event.attachment}`"
                  :download="`shippingLabel.${getMimeType(event.attachment).split('/')[1]}`"
                  style="color: white;"
                >Click to Download</a>
                  <iframe
                    v-if="event.attachment && getMimeType(event.attachment) == 'application/pdf'"
                    :src="`data:${getMimeType(event.attachment)};base64, ${event.attachment}`"
                    style="width:100%; height: 100%;"
                  />
                  <v-img
                    v-else-if="event.attachment"
                    :src="`data:image/jpg;base64, ${event.attachment}`"
                    style="width:100%;"
                  ></v-img>
                </div>
                
                  
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-actions v-if="total - events.length > 0">
        <v-btn
          @click="
            loadEvents({
              collection,
              id,
              loaded: events.length,
              persist: true
            })
          "
          color="secondary"
          dark
          block
          flat
        >
          Load
          {{ total - events.length > 5 ? 5 : total - events.length }}
          More
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Common from "@/mixins/Common";

export default {
  props: {
    collection: String,
    id: String,
    color: String,
    reload: { type: Boolean, default: false }
  },

  data() {
    return {
      valid: false,
      note: ""
    };
  },

  computed: {
    ...mapGetters({
      events: "chatter/getEvents",
      total: "chatter/getTotal",
      user: "app/getUser"
    })
  },

  destroyed() {
    this.clearChatter();
  },

  methods: {
    ...mapActions({
      logEvent: "chatter/logEvent",
      loadEvents: "chatter/load",
      clearChatter: "chatter/clearChatter"
    }),

    logIt() {
      if (this.valid && this.$refs.form.validate()) {
        this.logEvent({
          note: this.note,
          collection: this.collection,
          id: this.id,
          event: "chat",
          user: this.user.displayName
        });

        this.note = "";
        document.getElementById("note").focus();
        this.$store.dispatch("app/setSnackbar", {
          text: `Your message has been posted successfully!`,
          color: "green"
        });
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "You must enter a message to post to the thread.",
          color: "red"
        });
      }
    },

    getMimeType(b64) {
     
      let signatures = {
        JVBERi0: "application/pdf",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg"
      };

      for (var s in signatures) {
        if (b64.indexOf(s) === 0) {
          return signatures[s];
        }
      }
    }
  },

  beforeMount() {
    this.clearChatter();
  },

  mounted() {
    this.clearChatter();
    this.loadEvents({
      collection: this.collection,
      id: this.id,
      loaded: 0
    });
  },

  watch: {
    id() {
      this.loadEvents({
        collection: this.collection,
        id: this.id,
        loaded: this.reload ? 0 : this.events.length
      });
    }
  },

  mixins: [Common]
};
</script>
